import { render } from "./CreateProduct.vue?vue&type=template&id=0d07b549"
import script from "./CreateProduct.vue?vue&type=script&lang=js"
export * from "./CreateProduct.vue?vue&type=script&lang=js"
script.render = render

export default script